import React, { useEffect, useState } from "react";
import {
  CModal,
  CModalBody,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { addAttributeRequest } from "../redux/attributeDispatcher";
import { hideAddAttributeModal, showAddAttributeModal } from "../redux/attributeModalDispatcher";
import Papa from "papaparse";

const AddAttribute = ({
  parentId = 0,
  buttonLabel = "Add Attribute",
  editMode = false,
  categoryData = {},
}) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [categoryName, setCategoryName] = useState("");
  const [showOnFilter, setShowOnFilter] = useState(false);
  const [description, setDescription] = useState("");

  const [inputType, setInputType] = useState("text");
  const [selectType, setSelectType] = useState("dropdown");
  const [multiSelect, setMultiSelect] = useState(false);
  const [options, setOptions] = useState([]);
  const [newOption, setNewOption] = useState("");
  const [attributes, setAttributes] = useState([]);
  useEffect(() => {
    console.log("category data------",editMode,categoryData);
    if (editMode && categoryData) {
      autoFill();
    }
  }, [editMode, categoryData]);

  const resetForm = () => {
    setCategoryName("");
    setDescription("");
    setInputType("text");
    setSelectType("");
    setMultiSelect(false);
    setOptions([]);
    setNewOption("");
  };
  const autoFill = ()=>{
    setCategoryName(categoryData.label || "");
    setInputType(categoryData.input_type || "text");
    setShowOnFilter(categoryData.is_filter==1?true:false);
    setSelectType(categoryData.type || "");
    setMultiSelect(!categoryData.is_single || false);
    if(categoryData.options_value===null || categoryData.options_value==='undefined' || categoryData.options_value===undefined){
      setOptions([]); 
    }
    else{
      setOptions(JSON.parse(categoryData.options_value)); 
    }

  };
  const handleAddMore = () => {
    if (categoryName.trim() === "") {
      alert("Label name is required");
      return null;
    }
    if (inputType === "select" && options.length === 0) {
      alert("Please add options for the select field");
      return null;
    }
  
    const newAttribute = {
      label: categoryName,
      category_id: parentId !== 0 ? parentId : "0",
      input_type: inputType,
      is_filter: showOnFilter ? 1 : 0,
      ...(inputType === "select" && {
        type: selectType || "dropdown",
        is_single: !multiSelect,
        options_value: options,
      }),
    };
  
    if (editMode) {
      newAttribute.id = categoryData.id;
    }
  
    setAttributes((prev) => [...prev, newAttribute]); // Update state asynchronously
    resetForm();
    return newAttribute; // Return newly created attribute for further use
  };
  // const handleAddMore=()=>{
  //   if (categoryName.trim() === "") {
  //     alert("Label name is required");
  //     return;
  //   }
  //   if (inputType === "select" && options.length === 0) {
  //     alert("Please add options for the select field");
  //     return;
  //   }
  
  //   const newAttribute = {
  //     label: categoryName,
  //     category_id: parentId !== 0 ? parentId : "0",
  //     input_type: inputType,
  //     is_filter: showOnFilter ? 1 : 0,
  //     ...(inputType === "select" && {
  //       type: selectType || "dropdown",
  //       is_single: !multiSelect,
  //       options_value: options,
  //     }),
  //   };

  //       if (editMode) {
  //         newAttribute.id = categoryData.id;
  //   }
  
  //   setAttributes([...attributes, newAttribute]);
  //   resetForm(); // Clears the form for the next attribute
  // }
  // Handle Add Attribute Submission

  const handleAddAttribute = () => {
    // Check if form has values filled
    const formHasValues = categoryName.trim() !== "" || 
                          (inputType === "select" && options.length > 0);
    console.log("formHasValues------------", formHasValues);
    let updatedAttributes = [...attributes];
  
    // If form has values, add them to attributes
    if (formHasValues) {
      const newAttribute = handleAddMore(); // Adds new attribute if valid
      
      if (!newAttribute) return; // Stop execution if validation fails
  
      updatedAttributes.push(newAttribute);
    }
    else{
      if(attributes.length===0){
        handleAddMore();
      }
    }
  
    if (updatedAttributes.length > 0) {
      dispatch(addAttributeRequest(updatedAttributes));
      setAttributes([]);
      resetForm();
      setIsModalVisible(false);
      dispatch(hideAddAttributeModal());
    }
  };


  // const handleAddAttribute = () => {
  //   if (attributes.length === 0) {
  //     handleAddMore();
  //     console.log("handle add more-----",attributes.length);

  //       console.log("handle add more----1-",attributes.length);
  //       if(attributes.length===0){
  //         return;
  //       }
  //       else{
          
  //           dispatch(addAttributeRequest(attributes));
  //           resetForm();
  //           setIsModalVisible(false);
  //           dispatch(hideAddAttributeModal());
  //       }
 
      
  //   }
  //   else{
  //     dispatch(addAttributeRequest(attributes));
  //     resetForm();
  //     setIsModalVisible(false);
  //     dispatch(hideAddAttributeModal());
  //   }

  //     // dispatch(addAttributeRequest(attributes));

  //   console.log("selectype-----------type",selectType);
  //   // if (categoryName.trim() === "") {
  //   //   alert("label name is required");
  //   //   return;
  //   // }
  //   // else if (inputType=="select") {
  //   //   if(options.length==0){
  //   //     alert("Please add options");
  //   //   return;
  //   //   }
  //   //   // alert("Attribute name is required");
  //   //   // return;
  //   // }

  //   // const data = {
  //   //   "label": categoryName,
  //   //   "category_id": parentId !== 0 ? parentId : "0",
  //   //   "input_type":inputType,
  //   //   "is_filter":showOnFilter?1:0,
  //   //   ...(inputType === "select" && {
  //   //     "type":selectType?selectType:'dropdown',
  //   //     "is_single":!multiSelect,
  //   //     "options_value":options,
  //   //   }),
  //   // };


  //   // console.log("date----------------",data);
  //   // return;
  //   // if (editMode) {
  //   //   data.id = categoryData.id;
  //   // }
    
    
  //   // resetForm();
  //   // setIsModalVisible(false);
  //   // dispatch(hideAddAttributeModal());
  // };


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          // Extract first column values and filter out empty values
          const values = result.data.map((row) => row[0]).filter(Boolean);
  
          console.log("Extracted values:", values);
  
          // Merge with existing options and remove duplicates
          const uniqueValues = Array.from(new Set([...options, ...values]));
  
          console.log("Unique values:", uniqueValues);
  
          setOptions(uniqueValues);
        },
        skipEmptyLines: true,
      });
    }

  };
  const handleDownloadSample = () => {
    const csvContent = "data:text/csv;charset=utf-8,value1\nvalue2\nvalue3\nvalue4";
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "sample.csv");
    document.body.appendChild(link);
    link.click();
  };

  const handleRemoveAttribute = (indexToRemove) => {
    setAttributes(attributes.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div>

      <button
        onClick={() => {
          if (!editMode) {
            resetForm();
          }
          else{
            autoFill();
          }
          setIsModalVisible(true);
          dispatch(showAddAttributeModal());
        }}
        style={{
          backgroundColor: editMode ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode ? "10px" : "14px",
          minWidth: "60px",
          height: editMode ? "24px" : "30px",
          padding: editMode ? "2px 5px" : "4px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {buttonLabel}
      </button>

      {/* Modal */}
      <CModal
      
      
        alignment="center"
        visible={isModalVisible}

        onClose={() => setIsModalVisible(false)}
        className="attributemodal"
      >
        <CModalBody >
  <div className="main-container createAdmin">

    {/* Close Button */}
    <div className="cross-btn-div d-flex justify-content-end">
      <img
        onClick={() => setIsModalVisible(false)}
        src={crossButton}
        alt="close"
        className="cross-button"
      />
    </div>

    <form onSubmit={(e) => e.preventDefault()} className="login-form">
      {/* Header */}
      <div className="mb-4">
        <h4 className="h4 fw-bold text-center" style={{ color: "#007bff" }}>
          {editMode ? "Edit Attribute" : "Add New Attribute"}
        </h4>
      </div>

      {/* Row 1: Label Name + Show on Filter */}
      <div className="row mb-3 align-items-end">
        <div className="col-md-6">
          <label className="form-label">Label Name</label>
          <input
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            name="name"
            type="text"
            className="form-control login-input"
            placeholder="Enter label name"
          />
        </div>
        <div className="col-md-6 d-flex align-items-center">
          <input
            type="checkbox"
            checked={showOnFilter}
            onChange={() => setShowOnFilter(!showOnFilter)}
            className="form-check-input me-2"
            id="showOnFilter"
          />
          <label className="form-check-label" htmlFor="showOnFilter" style={{height:"38px", lineHeight:"38px"}}>
            Show on Filter
          </label>
        </div>
      </div>

      {/* Row 2: Input Type + Type of Select (if selected) */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Input Type</label>
          <select
            value={inputType}
            onChange={(e) => setInputType(e.target.value)}
            className="form-control login-input"
          >
            <option value="text">Text</option>
            <option value="number">Number</option>
            <option value="select">Select</option>
          </select>
        </div>
        {inputType === "select" && (
          <div className="col-md-6">
            <label className="form-label">Type of Select</label>
            <select
              value={selectType}
              onChange={(e) => setSelectType(e.target.value)}
              className="form-control login-input"
            >
              <option value="dropdown">Dropdown</option>
              <option value="radio">Radio</option>
              <option value="checkbox">Checkbox</option>
            </select>
          </div>
        )}
      </div>

      {/* Row 3: Multi-select (Only if select type is chosen) */}
      {inputType === "select"&&false && (
        <div className="row mb-3">
          <div className="col-md-12 d-flex align-items-center">
            <input
              type="checkbox"
              checked={multiSelect}
              onChange={() => setMultiSelect(!multiSelect)}
              className="form-check-input me-2"
              id="multiSelectCheckbox"
            />
            <label className="form-check-label" htmlFor="multiSelectCheckbox">
              Is Multi-select
            </label>
          </div>
        </div>
      )}

      {/* Row 4: Add Options (Only if input type is select) */}
      {inputType === "select" && (
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="row" style={{marginBottom:"5px"}}>
            <label className="form-label col-md-4">Add Options</label>
            <div className="col-md-8" style={{textAlign:'right'}}>
              <input type="file" id="getcsvfile" accept=".csv" style={{display:'none'}} onChange={handleFileUpload} />
              <button
                   onClick={handleDownloadSample}
                  type="button"
                  className="btn btn-sm text-primary"
                >Download Sample</button>
              <button
                   onClick={() => document.getElementById("getcsvfile").click()}
                  type="button"
                  className="btn btn-sm btn-success"
                >Import csv</button>
            </div>
            </div>
            
            <input
              type="text"
              value={newOption}
              onChange={(e) => setNewOption(e.target.value)}
              className="form-control login-input"
              placeholder="Add option and press Enter"
              onKeyDown={(e) => {
                if (e.key === "Enter" && newOption.trim() !== "") {
                  setOptions([...options, newOption]);
                  setNewOption("");
                  e.preventDefault();
                }
              }}
            />
          </div>
        </div>
      )}

      {/* Show Options as Chips */}
      {inputType === "select" && options.length > 0 && (
        <div className="row mb-3">
        <div className="col-md-12 d-flex flex-wrap gap-2">
          {options.map((opt, index) => (
            <div
              key={index}
              className="chip-container d-flex align-items-center justify-content-between"
            >
              <span className="chip-text">{opt}</span>
              <button
                type="button"
                className="btn-close chip-close"
                onClick={() => setOptions(options.filter((_, i) => i !== index))}
                aria-label="Close"
              ></button>
            </div>
          ))}
        </div>
      </div>
      )}
      {

            editMode==false&&
            <div style={{textAlign:"right", marginBottom:"20px"}}>
                  <button
                  
                  className="w-100 btn btn-md btn-outline-primary fw-bold "
                  type="button"
                  onClick={handleAddMore}
                >
                  {"+ Add More"}
                </button>
            </div>
     
      }
  {attributes.length > 0 && (
    <div className="mb-3">
      <h6 className="fw-bold">Attributes to be added:</h6>
    <div className="row">
      {attributes.map((attr, index) => (
        <div key={index} className="col-md-12">
          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <div className="row">
                <div className="col-md-11">
                <p  style={{fontSize:"13px", marginBottom:"0px"}}>
                <span className="fw-bold" style={{fontSize:"15px"}}>{attr.label}</span> ({attr.input_type}{attr.input_type=="select"&&" - "}{attr.input_type=="select"&&attr.type} | {"filter: "}{attr.is_filter ? "Yes" : "No"})   
                
            </p>
                </div>
                <div className="col-md-1">
                <button
             
             className="btn btn-sm text-danger"
             style={{position:"absolute", top:"8px", right:"8px"}}
             onClick={() => handleRemoveAttribute(index)}
           >
          <i className="fas fa-trash"></i>
           </button>
           </div>
                </div>
         

              {attr.input_type === "select" && (
                <>
                  <p  style={{fontSize:"13px", marginBottom:"0px"}}>
                    <strong>Options:</strong> {attr.options_value?.join(", ") || "N/A"}
                  </p>
                </>
              )}
           
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  )}
      {/* Submit Button */}
      <button
        className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
        type="button"
        onClick={handleAddAttribute}
      >
        {editMode ? "Update" : "Submit"}
      </button>
    </form>
  </div>
</CModalBody>
      </CModal>
    </div>
  );
};

export default AddAttribute;